import {
  NewEnrollmentInDto,
  NewEnrollmentOutDto,
} from "../../../types/enrollment.dto";

export const NEW_ENROLLMENT = "NEW_ENROLLMENT";
export const NEW_ENROLLMENT_SUCCESS = "NEW_ENROLLMENT_SUCCESS";
export const NEW_ENROLLMENT_ERROR = "NEW_ENROLLMENT_ERROR";
export const RESET_NEW_ENROLLMENT = "RESET_NEW_ENROLLMENT";

export interface CreateOneEnrollment {
  type: typeof NEW_ENROLLMENT;
  payload: NewEnrollmentOutDto;
}

export interface CreateOneEnrollmentSuccess {
  type: typeof NEW_ENROLLMENT_SUCCESS;
  payload: NewEnrollmentInDto;
}

export interface CreateOneEnrollmentError {
  type: typeof NEW_ENROLLMENT_ERROR;
  payload: string | boolean;
}

export interface ResetCreateOneEnrollment {
  type: typeof RESET_NEW_ENROLLMENT;
  payload: null;
}

export interface State {
  data: NewEnrollmentInDto | null;
  states: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
};

export type Actions =
  | CreateOneEnrollment
  | CreateOneEnrollmentSuccess
  | CreateOneEnrollmentError
  | ResetCreateOneEnrollment;
